import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Theme, Platform } from '../types'

interface UIState {
  theme: Theme
  sidebarOpen: boolean
  activeTab: Platform
  toastMessage: string | null
  toastType: 'success' | 'error' | 'info'

  setTheme: (theme: Theme) => void
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  setActiveTab: (tab: Platform) => void
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void
  hideToast: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      theme: 'system',
      sidebarOpen: true,
      activeTab: 'twitter',
      toastMessage: null,
      toastType: 'info',

      setTheme: (theme) => set({ theme }),

      toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

      setSidebarOpen: (open) => set({ sidebarOpen: open }),

      setActiveTab: (tab) => set({ activeTab: tab }),

      showToast: (message, type = 'info') => {
        set({ toastMessage: message, toastType: type })
        // Auto-hide after 3 seconds
        setTimeout(() => {
          set({ toastMessage: null })
        }, 3000)
      },

      hideToast: () => set({ toastMessage: null }),
    }),
    {
      name: 'shellby-help-ui',
      partialize: (state) => ({
        theme: state.theme,
        sidebarOpen: state.sidebarOpen,
      }),
    }
  )
)
